import { Injectable } from '@angular/core';
import { UseCase } from '../../base/UserCase';
import { Observable } from 'rxjs';
import { EnclosuresRepository } from '../../repositories/enclosures/EnclosuresRepository';
import {
  EventsbyvenueRequestDTO,
  EventsbyvenueResponseDTO
} from 'src/app/data/dto/EnclosuresDTO';

@Injectable({
    providedIn: 'root'
})

export class EventsByEnclosuresUseCase implements UseCase<EventsbyvenueRequestDTO, EventsbyvenueResponseDTO>{
    constructor(
        private enclosuresRepository: EnclosuresRepository,
    ) { }

    execute(id: EventsbyvenueRequestDTO): Observable<EventsbyvenueResponseDTO> {
        return this.enclosuresRepository.eventsByEnclosures(id);
    }
}
